import React from 'react'

function PlugIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9.746" height="12.994" viewBox="0 0 9.746 12.994">
            <path id="Vector_-_2025-02-19T152515.659" data-name="Vector - 2025-02-19T152515.659" d="M8.121.812A.812.812,0,1,0,6.5.812V3.249H8.121ZM9.34,4.061H.406A.406.406,0,0,0,0,4.467v.812a.406.406,0,0,0,.406.406H.812V6.5a4.062,4.062,0,0,0,3.249,3.979v2.518H5.685V10.477A4.062,4.062,0,0,0,8.933,6.5V5.685H9.34a.406.406,0,0,0,.406-.406V4.467a.406.406,0,0,0-.406-.406ZM3.249.812a.812.812,0,1,0-1.624,0V3.249H3.249Z" fill="#828282" />
        </svg>
    )
}

export default PlugIcon